package com.flowyride.feature.planner.ui.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.offset
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.flowyride.core.map.MapClick
import com.flowyride.feature.planner.MapPickTarget
import com.flowyride.feature.planner.resources.Res
import com.flowyride.feature.planner.resources.map_pick_arrival
import com.flowyride.feature.planner.resources.map_pick_departure
import com.flowyride.feature.planner.resources.map_pick_save_place
import com.flowyride.feature.planner.resources.map_pick_stop
import org.jetbrains.compose.resources.stringResource

/** "Departure / stop / arrival here" popup anchored where the map was long-pressed. */
@Composable
internal fun MapPickMenu(
    click: MapClick?,
    canAddStop: Boolean,
    onPick: (MapClick, MapPickTarget) -> Unit,
    onSavePlace: (MapClick) -> Unit,
    onDismiss: () -> Unit,
) {
    val anchor = click ?: return
    Box(Modifier.offset(anchor.screenOffset.x, anchor.screenOffset.y)) {
        DropdownMenu(expanded = true, onDismissRequest = onDismiss) {
            DropdownMenuItem(
                text = { Text(stringResource(Res.string.map_pick_departure)) },
                onClick = { onPick(anchor, MapPickTarget.DEPARTURE) },
            )
            DropdownMenuItem(
                text = { Text(stringResource(Res.string.map_pick_stop)) },
                onClick = { onPick(anchor, MapPickTarget.STOP) },
                enabled = canAddStop,
            )
            DropdownMenuItem(
                text = { Text(stringResource(Res.string.map_pick_arrival)) },
                onClick = { onPick(anchor, MapPickTarget.ARRIVAL) },
            )
            DropdownMenuItem(
                text = { Text(stringResource(Res.string.map_pick_save_place)) },
                onClick = { onSavePlace(anchor) },
            )
        }
    }
}
